/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiContainersCreateContainerPost } from '../fn/containers/api-containers-create-container-post';
import { ApiContainersCreateContainerPost$Params } from '../fn/containers/api-containers-create-container-post';
import { apiContainersCreateContainerPost$Plain } from '../fn/containers/api-containers-create-container-post-plain';
import { ApiContainersCreateContainerPost$Plain$Params } from '../fn/containers/api-containers-create-container-post-plain';
import { apiContainersDeleteContainerDelete } from '../fn/containers/api-containers-delete-container-delete';
import { ApiContainersDeleteContainerDelete$Params } from '../fn/containers/api-containers-delete-container-delete';
import { apiContainersDeleteContainerDelete$Plain } from '../fn/containers/api-containers-delete-container-delete-plain';
import { ApiContainersDeleteContainerDelete$Plain$Params } from '../fn/containers/api-containers-delete-container-delete-plain';
import { apiContainersGetContainerGet } from '../fn/containers/api-containers-get-container-get';
import { ApiContainersGetContainerGet$Params } from '../fn/containers/api-containers-get-container-get';
import { apiContainersGetContainerGet$Plain } from '../fn/containers/api-containers-get-container-get-plain';
import { ApiContainersGetContainerGet$Plain$Params } from '../fn/containers/api-containers-get-container-get-plain';
import { apiContainersGetContainersPost } from '../fn/containers/api-containers-get-containers-post';
import { ApiContainersGetContainersPost$Params } from '../fn/containers/api-containers-get-containers-post';
import { apiContainersGetContainersPost$Plain } from '../fn/containers/api-containers-get-containers-post-plain';
import { ApiContainersGetContainersPost$Plain$Params } from '../fn/containers/api-containers-get-containers-post-plain';
import { apiContainersGetContainerTypesPost } from '../fn/containers/api-containers-get-container-types-post';
import { ApiContainersGetContainerTypesPost$Params } from '../fn/containers/api-containers-get-container-types-post';
import { apiContainersGetContainerTypesPost$Plain } from '../fn/containers/api-containers-get-container-types-post-plain';
import { ApiContainersGetContainerTypesPost$Plain$Params } from '../fn/containers/api-containers-get-container-types-post-plain';
import { apiContainersUpdateContainerPatch } from '../fn/containers/api-containers-update-container-patch';
import { ApiContainersUpdateContainerPatch$Params } from '../fn/containers/api-containers-update-container-patch';
import { apiContainersUpdateContainerPatch$Plain } from '../fn/containers/api-containers-update-container-patch-plain';
import { ApiContainersUpdateContainerPatch$Plain$Params } from '../fn/containers/api-containers-update-container-patch-plain';
import { CreateContainerCommandResult } from '../models/create-container-command-result';
import { DeleteContainerCommandResult } from '../models/delete-container-command-result';
import { GetContainerQueryResult } from '../models/get-container-query-result';
import { GetContainersQueryResult } from '../models/get-containers-query-result';
import { GetContainerTypesQueryResult } from '../models/get-container-types-query-result';
import { UpdateContainerCommandResult } from '../models/update-container-command-result';

@Injectable({ providedIn: 'root' })
export class ContainersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiContainersGetContainerGet()` */
  static readonly ApiContainersGetContainerGetPath = '/api/Containers/GetContainer';

  /**
   * دي بترجعلك بورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersGetContainerGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiContainersGetContainerGet$Plain$Response(params?: ApiContainersGetContainerGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerQueryResult>> {
    return apiContainersGetContainerGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك بورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersGetContainerGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiContainersGetContainerGet$Plain(params?: ApiContainersGetContainerGet$Plain$Params, context?: HttpContext): Observable<GetContainerQueryResult> {
    return this.apiContainersGetContainerGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContainerQueryResult>): GetContainerQueryResult => r.body)
    );
  }

  /**
   * دي بترجعلك بورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersGetContainerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiContainersGetContainerGet$Response(params?: ApiContainersGetContainerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerQueryResult>> {
    return apiContainersGetContainerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك بورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersGetContainerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiContainersGetContainerGet(params?: ApiContainersGetContainerGet$Params, context?: HttpContext): Observable<GetContainerQueryResult> {
    return this.apiContainersGetContainerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContainerQueryResult>): GetContainerQueryResult => r.body)
    );
  }

  /** Path part for operation `apiContainersGetContainersPost()` */
  static readonly ApiContainersGetContainersPostPath = '/api/Containers/GetContainers';

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersGetContainersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainersPost$Plain$Response(params?: ApiContainersGetContainersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainersQueryResult>> {
    return apiContainersGetContainersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersGetContainersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainersPost$Plain(params?: ApiContainersGetContainersPost$Plain$Params, context?: HttpContext): Observable<GetContainersQueryResult> {
    return this.apiContainersGetContainersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContainersQueryResult>): GetContainersQueryResult => r.body)
    );
  }

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersGetContainersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainersPost$Response(params?: ApiContainersGetContainersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainersQueryResult>> {
    return apiContainersGetContainersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersGetContainersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainersPost(params?: ApiContainersGetContainersPost$Params, context?: HttpContext): Observable<GetContainersQueryResult> {
    return this.apiContainersGetContainersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContainersQueryResult>): GetContainersQueryResult => r.body)
    );
  }

  /** Path part for operation `apiContainersGetContainerTypesPost()` */
  static readonly ApiContainersGetContainerTypesPostPath = '/api/Containers/GetContainerTypes';

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersGetContainerTypesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainerTypesPost$Plain$Response(params?: ApiContainersGetContainerTypesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerTypesQueryResult>> {
    return apiContainersGetContainerTypesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersGetContainerTypesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainerTypesPost$Plain(params?: ApiContainersGetContainerTypesPost$Plain$Params, context?: HttpContext): Observable<GetContainerTypesQueryResult> {
    return this.apiContainersGetContainerTypesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContainerTypesQueryResult>): GetContainerTypesQueryResult => r.body)
    );
  }

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersGetContainerTypesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainerTypesPost$Response(params?: ApiContainersGetContainerTypesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerTypesQueryResult>> {
    return apiContainersGetContainerTypesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك ليست من البورتفوليو او البرنامج او البرنامج الفرعي من غير ولادها
   * if companyId == null it will return all Containers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersGetContainerTypesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersGetContainerTypesPost(params?: ApiContainersGetContainerTypesPost$Params, context?: HttpContext): Observable<GetContainerTypesQueryResult> {
    return this.apiContainersGetContainerTypesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContainerTypesQueryResult>): GetContainerTypesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiContainersCreateContainerPost()` */
  static readonly ApiContainersCreateContainerPostPath = '/api/Containers/CreateContainer';

  /**
   * دا علشان تنشئ بورتفوليو او البرنامج او البرنامج الفرعي اللي تحتيه مجموعه من مشاريع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersCreateContainerPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersCreateContainerPost$Plain$Response(params?: ApiContainersCreateContainerPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContainerCommandResult>> {
    return apiContainersCreateContainerPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تنشئ بورتفوليو او البرنامج او البرنامج الفرعي اللي تحتيه مجموعه من مشاريع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersCreateContainerPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersCreateContainerPost$Plain(params?: ApiContainersCreateContainerPost$Plain$Params, context?: HttpContext): Observable<CreateContainerCommandResult> {
    return this.apiContainersCreateContainerPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateContainerCommandResult>): CreateContainerCommandResult => r.body)
    );
  }

  /**
   * دا علشان تنشئ بورتفوليو او البرنامج او البرنامج الفرعي اللي تحتيه مجموعه من مشاريع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersCreateContainerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersCreateContainerPost$Response(params?: ApiContainersCreateContainerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContainerCommandResult>> {
    return apiContainersCreateContainerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تنشئ بورتفوليو او البرنامج او البرنامج الفرعي اللي تحتيه مجموعه من مشاريع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersCreateContainerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersCreateContainerPost(params?: ApiContainersCreateContainerPost$Params, context?: HttpContext): Observable<CreateContainerCommandResult> {
    return this.apiContainersCreateContainerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateContainerCommandResult>): CreateContainerCommandResult => r.body)
    );
  }

  /** Path part for operation `apiContainersUpdateContainerPatch()` */
  static readonly ApiContainersUpdateContainerPatchPath = '/api/Containers/UpdateContainer';

  /**
   * دا علشان تعدل ع البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersUpdateContainerPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersUpdateContainerPatch$Plain$Response(params?: ApiContainersUpdateContainerPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateContainerCommandResult>> {
    return apiContainersUpdateContainerPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تعدل ع البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersUpdateContainerPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersUpdateContainerPatch$Plain(params?: ApiContainersUpdateContainerPatch$Plain$Params, context?: HttpContext): Observable<UpdateContainerCommandResult> {
    return this.apiContainersUpdateContainerPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateContainerCommandResult>): UpdateContainerCommandResult => r.body)
    );
  }

  /**
   * دا علشان تعدل ع البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersUpdateContainerPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersUpdateContainerPatch$Response(params?: ApiContainersUpdateContainerPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateContainerCommandResult>> {
    return apiContainersUpdateContainerPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تعدل ع البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersUpdateContainerPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersUpdateContainerPatch(params?: ApiContainersUpdateContainerPatch$Params, context?: HttpContext): Observable<UpdateContainerCommandResult> {
    return this.apiContainersUpdateContainerPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateContainerCommandResult>): UpdateContainerCommandResult => r.body)
    );
  }

  /** Path part for operation `apiContainersDeleteContainerDelete()` */
  static readonly ApiContainersDeleteContainerDeletePath = '/api/Containers/DeleteContainer';

  /**
   * دا علشان تمسح البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersDeleteContainerDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersDeleteContainerDelete$Plain$Response(params?: ApiContainersDeleteContainerDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteContainerCommandResult>> {
    return apiContainersDeleteContainerDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersDeleteContainerDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersDeleteContainerDelete$Plain(params?: ApiContainersDeleteContainerDelete$Plain$Params, context?: HttpContext): Observable<DeleteContainerCommandResult> {
    return this.apiContainersDeleteContainerDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteContainerCommandResult>): DeleteContainerCommandResult => r.body)
    );
  }

  /**
   * دا علشان تمسح البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContainersDeleteContainerDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersDeleteContainerDelete$Response(params?: ApiContainersDeleteContainerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteContainerCommandResult>> {
    return apiContainersDeleteContainerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح البورتفوليو او البرنامج او البرنامج الفرعي.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContainersDeleteContainerDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContainersDeleteContainerDelete(params?: ApiContainersDeleteContainerDelete$Params, context?: HttpContext): Observable<DeleteContainerCommandResult> {
    return this.apiContainersDeleteContainerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteContainerCommandResult>): DeleteContainerCommandResult => r.body)
    );
  }

}
